interface InsightListCardProps {
    title: string;
    items: string[];
}

export function InsightListCard({
    title,
    items,
}: InsightListCardProps) {
    return (
        <div className="rounded-2xl border border-border bg-card p-5">

            <h3 className="text-sm font-semibold">
                {title}
            </h3>

            <div className="mt-5 space-y-4">

                {items.map((item) => (

                    <div
                        key={item}
                        className="rounded-xl border border-border p-4"
                    >

                        <p className="text-sm leading-relaxed">
                            {item}
                        </p>

                    </div>

                ))}

            </div>

        </div>
    );
}